(() => {
  const enhance = () => {
    const main = document.querySelector('[data-cielohuk-document]');
    const body = main?.querySelector('.cielohuk-shopping-guide__body, .shopify-policy__body > .rte');
    if (!body || body.dataset.documentReady) return;
    const headings = [...body.children].filter(node => node.tagName === 'H2');
    if (!headings.length) return;
    body.dataset.documentReady = 'true';
    body.classList.add('cielohuk-document');
    const isGuide = !!body.closest('.cielohuk-shopping-guide');
    const title = main.querySelector('.cielohuk-shopping-guide__header h1, .shopify-policy__title h1');
    const innerTitle = body.querySelector(':scope > h1:first-child');
    if (title && innerTitle) {
      if (innerTitle.textContent.trim().length < 60) {
        title.textContent = innerTitle.textContent;
      } else {
        const subtitle = document.createElement('p');
        subtitle.className = 'cielohuk-document__subtitle';
        subtitle.textContent = innerTitle.textContent;
        title.after(subtitle);
      }
      innerTitle.remove();
    }
    const intro = document.createElement('div');
    intro.className = 'cielohuk-document__intro';
    const fragment = document.createDocumentFragment();
    fragment.append(intro);
    let section;
    for (const node of [...body.childNodes]) {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H2') {
        section = document.createElement('section');
        section.className = 'cielohuk-document__chapter';
        fragment.append(section);
      }
      (section || intro).append(node);
    }
    body.append(fragment);
    if (!intro.textContent.trim()) intro.remove();
    const toc = document.createElement('details');
    toc.className = 'cielohuk-document__toc';
    toc.open = isGuide && window.matchMedia('(min-width: 768px)').matches;
    const summary = document.createElement('summary');
    summary.textContent = main.dataset.contentsLabel;
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', main.dataset.contentsLabel);
    const list = document.createElement('ol');
    headings.forEach((heading, index) => {
      if (!heading.id) {
        let id = `cielohuk-document-section-${index + 1}`;
        while (document.getElementById(id)) id += '-heading';
        heading.id = id;
      }
      heading.tabIndex = -1;
      heading.parentElement.setAttribute('aria-labelledby', heading.id);
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      link.addEventListener('click', () => heading.focus({ preventScroll: true }));
      item.append(link);
      list.append(item);
    });
    nav.append(list);
    toc.append(summary, nav);
    body.querySelector('.cielohuk-document__chapter').before(toc);
    if (isGuide) {
      body.querySelectorAll('.cielohuk-document__chapter > ol').forEach(list => {
        list.classList.add('cielohuk-document__steps');
      });
    }
    body.querySelectorAll('table').forEach(table => {
      const wrapper = table.closest('.hdt-scrollable-wrapper, .table-scroll') || table.parentElement;
      if (wrapper !== body && wrapper !== table.closest('section')) {
        wrapper.classList.add('cielohuk-document__table');
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        const heading = table.closest('section')?.querySelector('h2');
        if (heading) wrapper.setAttribute('aria-labelledby', heading.id);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', enhance, { once: true });
  else enhance();
  document.addEventListener('shopify:section:load', enhance);
})();
